import { getLocaleId } from '@angular/common';
import {
  Component, Input, OnInit, ViewChild
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { deLocale } from 'ngx-bootstrap/locale';

import { ModifierTypes } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss']
})

export class InputDatepickerComponent implements OnInit {
  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() placeholder = '';

  @Input() layoutMod: ModifierTypes[] = [];

  @Input() config!: BsDatepickerConfig;

  @Input() range = true;

  @Input() value?: Date | Date[];

  layoutModifier = '';

  control!: AbstractControl | null;

  @ViewChild('datepicker') datepicker!: any;

  constructor(
    private stylingService: StylingService,
    private localeService: BsLocaleService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    const locale = getLocaleId('de');
    defineLocale(locale, deLocale);
    this.localeService.use(locale);

    this.control = this.mainForm.get(this.controlName);
    this.layoutModifier = this.stylingService.concatLayoutModifiers('inputField', this.layoutMod);
  }

  toggle(): void {
    this.datepicker.toggle();
  }
}
